import { createSignal } from "solid-js";

import createUpdate from "@repo/signals/createUpdate";

export const invalidate = createUpdate();

export const mounted = (() => {
  const [mounted, setMounted] = createSignal(false);

  return Object.assign(mounted, {
    notify() {
      setMounted(true);
    },
  });
})();
